/**
 * Nombre comercial visible para el cliente. Corrige la grafía antigua «Pizas» → «Pizzas»
 * solo en pantalla (no modifica datos guardados, carpetas, variables de entorno ni dominios).
 */
export function displayBrandName(name, fallback = 'Pizzas') {
  const raw = String(name || '').trim() || fallback;
  return raw.replace(/\bPizas\b/g, 'Pizzas');
}
